import { render, staticRenderFns } from "./ConferenceInfo.vue?vue&type=template&id=ad1ca582&scoped=true&"
import script from "./ConferenceInfo.vue?vue&type=script&lang=js&"
export * from "./ConferenceInfo.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceInfo.vue?vue&type=style&index=0&id=ad1ca582&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1ca582",
  null
  
)

export default component.exports